import { platform } from "utils/api/generated/manucoApi";

// Issue #23 (rechten F2 §1): de eigen activeerbare rol (BEHEER altijd, een zakelijke rol als Beheer dat per toewijzing
// zo zette) tijdelijk aanzetten, met optionele reden en hoogstens 8 uur. Enkel de eigenaar zelf; elke aangemelde gebruiker mag
// de operatie aanroepen, de proc controleert dat de toewijzing van de beller is (52171/52172). Activeren vraagt
// step-up (apiClient vraagt dan zelf een sterker token). Schrijven nooit opnieuw proberen.

export const MAX_ACTIVATION_HOURS = 8;
const WRITE = { retries: 0 };

// POST /v2/access/activations { idAssignment, hours, reason } → de activatie (expiresAt)
export function startActivation(tokenProvider, { idAssignment, hours, reason }) {
  return platform.accessActivationStart(
    tokenProvider,
    { idAssignment, hours: Math.min(MAX_ACTIVATION_HOURS, Math.max(1, Math.round(Number(hours) || 1))), reason: String(reason || "").trim() },
    WRITE
  );
}

// POST /v2/access/activations/{idAssignment}/end — de lopende activatie stoppen (idempotent)
export function endActivation(tokenProvider, { idAssignment }) {
  return platform.accessActivationEnd(tokenProvider, { idAssignment }, WRITE);
}
